import * as React from 'react';
import { lazyLoad } from '../../../utils/loadable';

export const LangSmithPage = props => {
  return lazyLoad(
    () => import('./index'),
    module => module.LangSmithPage,
    { fallback: <div></div> },
  )(props);
};
